
import { LayoutTypeFacet } from '../../models/layouts/LayoutTypeFacet';

export const tilesLayoutType = new LayoutTypeFacet('tiles');
